import { addBookingToFirestore, getAllBookingsFromFirestore } from './firestoreBooking';

// Migrate localStorage-only bookings to Firestore
export const migrateLocalStorageBookingsToFirestore = async () => {
  try {
    console.log('🔄 Starting localStorage to Firestore migration...');
    
    // Get all bookings from localStorage
    const localBookings = JSON.parse(localStorage.getItem('userBookings') || '[]');
    console.log('📦 Found', localBookings.length, 'bookings in localStorage');
    
    if (localBookings.length === 0) {
      console.log('✅ No localStorage bookings to migrate');
      return { migrated: 0, skipped: 0, failed: 0 };
    }
    
    // Get existing Firestore bookings to avoid duplicates
    const firestoreBookings = await getAllBookingsFromFirestore();
    const firestoreIds = new Set(firestoreBookings.map(b => b.id));
    
    let migrated = 0;
    let skipped = 0;
    let failed = 0;
    
    for (const localBooking of localBookings) {
      try {
        if (firestoreIds.has(localBooking.id)) {
          console.log('⏭️ Skipping', localBooking.id, '- already exists in Firestore');
          skipped++;
          continue;
        }
        
        // Prepare booking data for Firestore
        const bookingData = {
          ...localBooking,
          // Ensure required fields
          createdAt: localBooking.createdAt || new Date().toISOString(),
          paymentMethod: localBooking.paymentMethod || 'offline',
          status: localBooking.status || 'confirmed',
          payment: localBooking.payment || 'pending',
          // Mark as migrated
          migratedFromLocalStorage: true,
          migratedAt: new Date().toISOString()
        };
        
        await addBookingToFirestore(bookingData);
        console.log('✅ Migrated booking', localBooking.id, 'to Firestore');
        migrated++;
        
      } catch (error) {
        console.error('❌ Failed to migrate booking', localBooking.id, ':', error);
        failed++;
      }
    }
    
    console.log('🎉 Migration complete:', { migrated, skipped, failed });
    return { migrated, skipped, failed };
    
  } catch (error) {
    console.error('❌ Migration failed:', error);
    throw error;
  }
};

// Check if there are localStorage-only bookings that need migration
export const checkForLocalStorageBookings = async () => {
  try {
    const localBookings = JSON.parse(localStorage.getItem('userBookings') || '[]');
    if (localBookings.length === 0) return { needsMigration: false, count: 0 };
    
    const firestoreBookings = await getAllBookingsFromFirestore();
    const firestoreIds = new Set(firestoreBookings.map(b => b.id));
    
    const localOnlyBookings = localBookings.filter(b => !firestoreIds.has(b.id));
    
    return {
      needsMigration: localOnlyBookings.length > 0,
      count: localOnlyBookings.length,
      bookings: localOnlyBookings
    };
  } catch (error) {
    console.error('Error checking localStorage bookings:', error);
    return { needsMigration: false, count: 0 };
  }
};
